import React, { useEffect, useState } from 'react';
import { useParams, useNavigate, Link } from 'react-router-dom';
import api from '@/api';

const VerifyEmail = () => {
  const { token } = useParams();
  const navigate = useNavigate();
  const [status, setStatus] = useState('verifying'); // verifying | success | error
  const [errorMsg, setErrorMsg] = useState('');

  useEffect(() => {
    const verify = async () => {
      try {
        await api.post(`/auth/verify-email/${token}`);
        setStatus('success');
        setTimeout(() => navigate('/login'), 2500);
      } catch (e) {
        setStatus('error');
        setErrorMsg(e.response?.data?.detail || 'Verification failed.');
      }
    };
    verify();
  }, [token, navigate]);

  return (
    <div className="min-h-screen bg-background flex items-center justify-center p-4">
      <div className="max-w-md w-full bg-surface border border-border rounded-[10px] p-10 text-center" data-testid="verify-email-card">
        <div className="flex items-center justify-center gap-2 mb-6">
          <div className="w-9 h-9 rounded-lg bg-text-primary text-white flex items-center justify-center font-bold text-lg">F</div>
          <h1 className="text-xl font-heading font-bold text-text-primary">Founderboard</h1>
        </div>

        {status === 'verifying' && (
          <div data-testid="verify-loading">
            <div className="w-12 h-12 mx-auto mb-4 border-2 border-primary border-t-transparent rounded-full animate-spin" />
            <p className="text-text-secondary">Verifying your email…</p>
          </div>
        )}

        {status === 'success' && (
          <div data-testid="verify-success">
            <div className="w-14 h-14 mx-auto mb-4 rounded-full bg-success/10 text-success flex items-center justify-center text-3xl">✓</div>
            <h2 className="text-2xl font-heading font-bold text-text-primary mb-2">You're verified 🎉</h2>
            <p className="text-text-secondary mb-6">Your email is confirmed. Redirecting you to log in…</p>
            <button
              onClick={() => navigate('/login')}
              className="bg-primary text-white px-6 py-2.5 rounded-lg font-medium hover:bg-primary/90 transition-colors"
              data-testid="verify-success-cta"
            >
              Go to Login
            </button>
          </div>
        )}

        {status === 'error' && (
          <div data-testid="verify-error">
            <div className="w-14 h-14 mx-auto mb-4 rounded-full bg-danger/10 text-danger flex items-center justify-center text-3xl">!</div>
            <h2 className="text-2xl font-heading font-bold text-text-primary mb-2">Link invalid</h2>
            <p className="text-text-secondary mb-6">{errorMsg}</p>
            <Link to="/login" className="text-primary text-sm font-medium" data-testid="verify-error-back">
              Back to Login →
            </Link>
          </div>
        )}
      </div>
    </div>
  );
};

export default VerifyEmail;
